import React from 'react';

const DashboardLoadingState = () => (
  <div className="min-h-[50vh] flex items-center justify-center">
    <div className="text-center">
      <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-matdash-primary mx-auto" />
      <p className="mt-4 text-matdash-muted">Loading dashboard...</p>
    </div>
  </div>
);

export default DashboardLoadingState;
